module.exports = __webpack_public_path__ + "static/img/new_ad1.98881fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_ad1.jpg
// module id = C+QH
// module chunks = 1